import {Edit, Trash2,} from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Brand from "../../../core/modals/inventory/brand";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { all_routes } from "../../../Router/all_routes";
import CommonMaterialReactTable from "../../MaterialReactTable/CommonMaterialReactTable";
import apiHandler from "../../common/api";
import { Box } from "@mui/material";
import "sweetalert2/dist/sweetalert2.min.css";
import HeaderModule from "../../components/Header/HeaderModule";

const ServiceTypeList = () => {
  const navigate = useNavigate();
  const [productlist, setProductlist] = useState([]);
  const [deletes, setdelete] = useState(false);
  const MySwal = withReactContent(Swal);
  const showConfirmationAlert = (ID) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(ID)
        MySwal.fire({
          title: "Deleted!",
          text: "Your service type has been deleted.",
          className: "btn btn-success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } else {
        MySwal.close();
      }
    });
  };

  const handleDelete = async (id) => {
    //console.log(id, "delete");

    let reqobj = {
      ID: id,
      Module: "serviceType",
    };
    const response = await apiHandler({
      method: "POST",
      route: "Superadmin/deletebymoduleid",
      payload: reqobj,
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      setdelete(!deletes);
    } else {
      console.log(response, "data");
    }
  };
  const columns = [
    {
      header: "ID",
      accessorKey: "ID",
      enableSorting: true,
      sortingFn: "numeric",
    },
    {
      header: "Service Name",
      accessorKey: "ServiceName",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Parent Name",
      accessorKey: "ParentName",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Service Description",
      accessorKey: "ServiceDescription",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },

    {
      accessorKey: "actions",
      header: "Actions",
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Box sx={{ display: "flex", gap: "0.5rem" }}>
          <button
           className="btn btn-outline-primary btn-sm me-2"
            // color="primary"
            onClick={() => {
              navigate(`${route.ServicesType}/${row.original.ID}`);
              console.log("Edit row:", row.original.ID);
            }}
          >
            <Edit className='custome-icon-size' />
          </button>
          <button
           className="btn btn-outline-primary btn-sm me-2"
            // color="error"
            onClick={() => {
              showConfirmationAlert(row.original.ID);
            }}
          >
            <Trash2 className='custome-icon-size' />
          </button>
        </Box>
      ),
    },
  ];

  const route = all_routes;

  const prodcutDataListApi = async () => {
    const response = await apiHandler({
      method: "GET",
      route: `Superadmin/serviceAll`,
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      setProductlist(response.ResponseData);
    } else {
      console.log(response, "data");
    }
  };

  useEffect(() => {
    prodcutDataListApi();
  }, [deletes]);

  const exportData = productlist.map((item) => ({
    ID: item?.ID,
    ServiceName: item?.ServiceName,
    ServiceDescription: item?.ServiceDescription,
  }));

  return (
    <div className="page-wrapper">
      <div className="content">
      <HeaderModule
          refreshData={prodcutDataListApi}
          exportData={exportData}
          addMasterPageLink={route.ServicesType}
        />
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-responsive">
              <CommonMaterialReactTable columns={columns} data={productlist} />
            </div>
          </div>
        </div>
        {/* /product list */}
        <Brand />
      </div>
    </div>
  );
};

export default ServiceTypeList;
